import React, { useState } from "react";

import Modal from "../Modal";
import { Title } from "../Form";
import Tabs from "../Tabs";

import { Content, VideoFrame } from "./styles";
import { IProps } from "./interfaces";
const YoutubePlayer = require("react-youtube-player").default;

export { default as Button } from "./Button";

const Tutorial = ({ audioplay, close, children, title, videoId }: IProps) => {
    const [videoState, setVideoState] = useState(audioplay ? "play" : "unstarted")
    return (
        <Modal close={close} width="616px" overflowHidden>
            <Title>{title}</Title>
            {videoId && (
                <VideoFrame>
                    <YoutubePlayer
                        videoId={videoId}
                        playbackState={videoState}
                        configuration={{
                            showinfo: 0,
                            controls: 1,
                            listType: "user_uploads",
                        }}
                        onPause={() => setVideoState("paused")}
                        onPlay={() => setVideoState("playing")}
                        onEnd={() => setVideoState("paused" )}
                    />
                </VideoFrame>
            )}
            <Content>
                <Tabs>{children}</Tabs>
            </Content>
        </Modal>
    );
}

export default Tutorial;
